export default {
  // 页面/Tab 标签
  供应商文件: "Supplier Files",
  供应商帐号: "Supplier Account",

  // 供应商列表
  供应商编号: "Supplier Number",
  代理商: "Agent",
  生产商: "Manufacturer",

  // 企业文件/物料文件
  企业文件: "Company Files",
  物料文件: "Material Files",
  通知供应商上传文件: "Notify Supplier to Upload Files",
  添加物料: "Add Material",

  // 物料项相关
  编辑物料: "Edit Material",
  删除物料: "Delete Material",
  确认是否删除此物料: "Are you sure you want to delete this material?",

  // 账号审核弹窗
  供应商账号审核: "Supplier Account Review",
  审核成功: "Review Successful",

  // 文件审核弹窗
  审批意见: "Approval Opinion",
  请选择审批意见: "Please Select Approval Opinion",
  通过: "Approve",
  驳回: "Reject",
  意见说明: "Comments",
  请填写意见说明: "Please Enter Comments",
  文件审核: "File Review",

  // 添加/编辑物料弹窗
  "抱歉，无法查询到该物料编号，请重新查询输入。":
    "Sorry, material number not found. Please search and enter again.",
  修改物料: "Modify Material",
  添加物料弹窗: "Add Material",
  根据物料编码搜索: "Search by Material Code",
  请输入物料编码: "Enter Material Code",
  物料编码: "Material Code",
  物料名称必填: "Please Enter Material Name",

  // 账号操作按钮
  禁用成功: "Disabled Successfully",
  禁用账号: "Disable Account",
  确定要禁用该账号吗: "Are you sure you want to disable this account?",
  禁用: "Disable",
  解禁成功: "Enabled Successfully",
  解禁账号: "Enable Account",
  确定要解禁该账号吗: "Are you sure you want to enable this account?",
  解禁: "Enable",
  审核按钮: "Review",

  // 表格列名
  序号: "No.",
  姓名: "Name",
  所属部门: "Department",
  电话号码: "Phone Number",
  注册状态: "Registration Status",
  最近登录时间: "Last Login Time",
  文件名称: "File Name",
  文件有效期至: "File Valid Until",
  文件状态: "File Status",
  最新上传时间: "Latest Upload Time",
  上传用户: "Uploaded By",
  最新版本: "Latest Version",
  上一版本: "Previous Version",

  // 操作相关
  驳回原因: "Rejection Reason",
  查看驳回原因: "View Rejection Reason",
  提醒对方: "Remind",
  审核操作: "Review",
  更新文件: "Update File",
  下载: "Download",

  // 成功提示消息
  发送成功: "Sent Successfully",
  保存成功: "Saved Successfully",
  修改成功: "Modified Successfully",
  删除成功: "Deleted Successfully",
  提交成功: "Submitted Successfully",
  通知发送成功: "Notification Sent Successfully",
  添加成功: "Added Successfully",

  // 其他
  添加: "Add",
  搜索: "Search",

  // AllTab 全部列表
  供应商阶段: "Supplier Stage",
  供应商名称中文: "Supplier Name (Chinese)",
  供应商名称英文: "Supplier Name (English)",
  供应商名称表单: "Supplier Name",
  工厂: "Factory",
  物料类别: "Material Category",
  采购类型: "Purchase Type",
  企业类型: "Business Type",
  已注册账号数量: "Registered Accounts",
  已添加物料数量: "Added Materials",
  待审核文件数量: "Pending Review Documents",
  负责人表格: "Responsible Person",
  全部列表: "All List",
  生产性物料: "Production Materials",
  非生产性物料: "Non-Production Materials",

  // FrozenTab Module
  冻结列表: "Freeze List",
  申请冻结: "Apply Freeze",
  供应商信息: "Supplier Information",
  冻结类型: "Freeze Type",
  禁止供货工厂: "Forbidden Supply Factory",
  禁止供货物料: "Forbidden Supply Material",
  冻结原因: "Freeze Reason",
  相关证明文件: "Related Proof Document",
  解冻原因: "Unfreeze Reason",
  申请类型: "Application Type",
  申请状态: "Application Status",
  表单编号: "Form Number",
  申请原因: "Application Reason",
  申请时间: "Application Time",
  申请人: "Applicant",
  重新提交: "Resubmit",
  解冻申请: "Unfreeze Application",
  冻结申请已提交: "Freeze application submitted",
  解冻申请已提交: "Unfreeze application submitted",
  审批成功: "Approval successful",
  审批中: "Under Review",
  已通过: "Approved",
  已驳回: "Rejected",
  供应商冻结: "Supplier Freeze",
  物料冻结: "Material Freeze",

  // Tab Labels
  全部: "All",
  注册: "Registered",
  评估: "Evaluation",
  准入: "Access",
  冻结: "Freeze",
  黑名单: "Blacklist",

  // AccessedTab Admission and Price Application
  准入申请: "Admission Application",
  价格申请: "Price Application",
  准入申请列表: "Admission Application List",
  价格申请列表: "Price Application List",
  申请准入: "Apply for Admission",
  "供应商名称（中文）": "Supplier Name (Chinese)",
  "供应商名称（英文）": "Supplier Name (English)",
  供应商地址: "Supplier Address",
  经营有效期至: "Business Valid Until",
  联系人电话: "Contact Phone",
  联系人邮箱: "Contact Email",
  货币: "Currency",
  付款条约: "Payment Terms",
  国际贸易条款: "Incoterms",
  删除: "Delete",
  申请变更: "Apply for Change",

  // Delete Confirmation
  "确定要删除此价格申请吗？":
    "Are you sure you want to delete this price application?",

  // Error and Success Messages
  "获取申请ID失败，无法编辑": "Failed to get application ID, unable to edit",
  "获取申请ID失败，无法查看": "Failed to get application ID, unable to view",
  "获取申请ID失败，无法申请变更":
    "Failed to get application ID, unable to apply for change",
  "获取申请ID失败，无法重新提交":
    "Failed to get application ID, unable to resubmit",
  "获取申请ID失败，无法删除": "Failed to get application ID, unable to delete",
  已获取申请详情: "Application details retrieved",
  获取申请详情失败: "Failed to get application details",
  "获取申请详情失败，请重试":
    "Failed to get application details, please try again",
  已获取供应商详情: "Supplier details retrieved",
  获取供应商详情失败: "Failed to get supplier details",
  "获取供应商详情失败，请重试":
    "Failed to get supplier details, please try again",
  "申请已通过，请等待下一步": "Application approved, please wait for next step",
  申请提交失败: "Application submission failed",
  "申请提交失败，請重試": "Application submission failed, please try again",
  "删除失败，请重试": "Delete failed, please try again",

  // Admission Application Modal
  供应商准入申请表: "Supplier Admission Application Form",
  单号: "Form Number",
  加载中: "Loading",
  下一步: "Next",
  上一步: "Previous",
  缺少必要的数据无法打开评估表单:
    "Missing necessary data, unable to open assessment form",
  获取评估详情失败: "Failed to get assessment details",
  "获取评估详情失败，请重试":
    "Failed to get assessment details, please try again",
  "获取单号失败，请重新打开": "Failed to get form number, please reopen",
  "无法获取用户信息，请重新登录":
    "Unable to get user information, please log in again",
  请至少添加一条银行信息: "Please add at least one bank information",
  请完整填写所有银行信息的必填字段:
    "Please complete all required fields for bank information",
  抱歉SAP没有这些标红的开户行行号:
    "Sorry, SAP does not have these highlighted bank account numbers",
  无法进行下一步: "Unable to proceed to next step",
  "检测开户行行号失败，请重试":
    "Failed to detect bank account number, please try again",
  请选择审核意见: "Please select review opinion",
  审批通过成功: "Approval passed successfully",
  驳回成功: "Rejection successful",
  "审批失败，请重试": "Approval failed, please try again",
  获取准入申请详情失败: "Failed to get admission application details",
  "获取准入申请详情失败，请重试":
    "Failed to get admission application details, please try again",
  "缺少流程单号，无法提交申请":
    "Missing process number, unable to submit application",
  "提交准入申请失败，请重试":
    "Failed to submit admission application, please try again",
  文件上传失败: "File upload failed",
  成功批量上传: "Batch upload successful",
  个文件: "files",
  "文件信息记录失败，但文件已成功上传到OSS":
    "File information recording failed, but file has been successfully uploaded to OSS",
  "表单验证失败，请检查表单错误":
    "Form validation failed, please check form errors",
  暂存: "Save Draft",
  提交: "Submit",
  审批通过: "Approved",

  // formConfig2.tsx Related Translations
  生产物料: "Production Materials",
  非生产物料: "Non-Production Materials",

  // formConfig.tsx Form Field Labels
  注册邮箱: "Registered Email",
  姓氏: "Last Name",
  名字: "First Name",
  员工姓名: "Employee Name",
  员工编号: "Employee Number",
  创建日期: "Creation Date",
  部门: "Department",
  岗位: "Position",
  邮箱: "Email",
  营业有效期: "Business Valid Period",
  "统一社会信用代码/商业登记号":
    "Unified Social Credit Code/Business Registration Number",
  生产商名称: "Manufacturer Name",
  国家: "Country",
  "省份/城市": "Province/City",
  邮编: "Postal Code",
  "街道/门牌号": "Street/House Number",
  语言: "Language",
  经营范围: "Business Scope",
  银行信息: "Bank Information",
  营业执照: "Business License",
  收款授权信: "Payment Authorization Letter",
  开户证明: "Account Opening Certificate",
  其他: "Other",

  // formConfig2.tsx Form Field Labels
  供应商编码: "Supplier Code",
  是否为GMP: "Is GMP",
  供应商等级: "Supplier Grade",
  采购小组: "Procurement Group",
  付款方式: "Payment Method",
  科目小组: "Subject Group",
  科目编号: "Subject Number",
  OA地址: "OA Address",
  PI发票方: "PI Invoice Party",
  审核意见: "Review Opinion",
  查看评估结果: "View Assessment Results",

  // formConfig2.tsx Form Group Titles
  供应商设置: "Supplier Settings",
  采购信息: "Procurement Information",
  财务信息: "Financial Information",
  其他合作信息: "Other Cooperation Information",
  准入评估结果: "Admission Assessment Results",

  // AdmissionApplicationModal Related
  流程动态: "Process Dynamics",

  // formConfig.tsx Form Group Titles
  申请人信息: "Applicant Information",
  供应商基本信息: "Supplier Basic Information",
  地址信息: "Address Information",
  注册人信息: "Registrant Information",

  // formConfig2.tsx Placeholders and Validation Messages
  请输入: "Please Enter",
  请选择: "Please Select",
  请输入邮箱: "Please Enter Email",
  "请输入...": "Please Enter...",

  // formConfig.tsx File Upload Related
  证照文件: "Certificate Files",
  下载全部: "Download All",
  点击上传: "Click to Upload",

  // PriceApplicationModal Related Translations
  供应商价格申请表: "Supplier Price Application Form",
  工号: "Employee ID",
  申请日期: "Application Date",
  申请信息: "Application Information",
  年度需求金额: "Annual Demand Amount",
  价格变动范围: "Price Change Range",
  是否为首次采购: "Is First Purchase",
  价格申请原因: "Price Application Reason",
  询比议价过程: "Inquiry and Negotiation Process",
  报价单: "Quotation",
  询比议价结果: "Inquiry and Negotiation Result",
  价格明细: "Price Details",
  审批信息: "Approval Information",
  审批说明: "Approval Description",
  同意: "Agree",
  取消: "Cancel",
  暂无数据: "No Data",
  请先选择工厂: "Please Select Factory First",
  请先选择供应商: "Please Select Supplier First",
  物料获取成功: "Materials Retrieved Successfully",
  供应商选择成功: "Supplier Selected Successfully",
  工厂选择成功: "Factory Selected Successfully",
  报价单选择成功: "Quotation Selected Successfully",
  请先选择至少一个报价单: "Please Select At Least One Quotation",
  暂存成功: "Draft Saved Successfully",
  暂存失败请重试: "Failed to Save Draft, Please Try Again",
  提交失败请重试: "Failed to Submit, Please Try Again",
  请先完成表单填写: "Please Complete Form First",
  获取供应商信息失败: "Failed to Get Supplier Information",
  获取供应商信息失败请重试:
    "Failed to Get Supplier Information, Please Try Again",
  生成单号失败: "Failed to Generate Form Number",
  获取物料失败: "Failed to Get Materials",
  获取物料失败请重试: "Failed to Get Materials, Please Try Again",
  获取汇率成功汇率: "Exchange Rate Retrieved Successfully, Rate: ",
  获取汇率失败: "Failed to Get Exchange Rate",
  获取汇率失败请重试: "Failed to Get Exchange Rate, Please Try Again",
  获取失败检测为首次采购与列表物料冲突所申请物料必须均为首次采购或非首次采购:
    "Failed to Get, Detected First Purchase Conflict with List Materials, All Applied Materials Must Be Either First Purchase or Non-First Purchase!",
  物料删除成功: "Material Deleted Successfully",
  数据加载成功: "Data Loaded Successfully",
  获取申请详情失败请重试: "Failed to Get Application Details, Please Try Again",
  获取历史记录失败: "Failed to Get History Records",

  // QuotationModal Related Translations
  询比单号: "Inquiry Number",
  询比名称: "Inquiry Name",
  截止时间: "Deadline",
  询比状态: "Inquiry Status",
  创建人: "Creator",
  询比中: "Under Inquiry",
  已完成: "Completed",
  确认选择: "Confirm Selection",
  加载失败请重试: "Failed to Load, Please Try Again",
  暂无报价单: "No Quotations",
  共_条数据: "Total {total} Records",

  // formConfig.tsx Form Field Labels
  "New Price 新价格": "New Price",
  "Price Decrease 降价": "Price Decrease",
  "Price Increase 加价": "Price Increase",
  "A materia ls A类物料": "A Materials Type A Materials",
  "B,C materials and new materials+AF OEM out products B,C类物料和新物料+AF委外采购产品":
    "B,C Materials and New Materials+AF OEM Out Products",
  "Lab study, scale up materials 研发中小试和中试物料":
    "Lab Study, Scale-up Materials",
  "Type A,B Material A类物料/B类物料": "Type A,B Material",
  "Type C,D Material C,D类物料": "Type C,D Material",
  "RD scale up raw material(Equvalent to D material) 研发中试物料":
    "RD Scale-up Raw Material (Equivalent to D Material)",
  "All Material 所有物料": "All Materials",
  "Type A/B Material A类物料/B类物料": "Type A/B Material",
  "Type C/D Material(inlcude scale up materials) C类物料/D类物料":
    "Type C/D Material (Include Scale-up Materials)",
  "A materials A类物料": "A Materials",
  "RD scale up raw material 研发中试物料": "RD Scale-up Raw Material",
  "Smaller than 300K 小于30万": "Smaller than 300K",
  "Equal or bigger than 300K 大于或等于30万": "Equal or Bigger than 300K",
  "Smaller than 500K 小于50万": "Smaller than 500K",
  "Equal or bigger than 500K 大于或等于50万": "Equal or Bigger than 500K",
  All: "All",
  "Smaller than 小于10%": "Smaller than 10%",
  "Equal or bigger than 10% 大于或等于10%": "Equal or Bigger than 10%",
  "Smaller than 30% 小于30%": "Smaller than 30%",
  "Equal or bigger than 30% 大于或等于30%": "Equal or Bigger than 30%",
  是: "Yes",
  否: "No",

  // formConfig.tsx Placeholders and Button Text
  请选择供应商: "Please Select Supplier",
  请选择工厂: "Please Select Factory",
  请选择申请类型: "Please Select Application Type",
  请先选择申请类型: "Please Select Application Type First",
  请选择年度需求金额: "Please Select Annual Demand Amount",
  请选择价格变动范围: "Please Select Price Change Range",
  请输入文本: "Please Enter Text",
  请选择报价单: "Please Select Quotation",
  获取物料: "Get Materials",
  请输入审批说明: "Please Enter Approval Description",
  // formConfig.tsx Form Field Labels
  物料编号: "Material Number",
  物料名称: "Material Name",
  项目: "Project",
  预计交货天数: "Estimated Delivery Days",
  "标准数量（SAP包装单位）": "Standard Quantity (SAP Packaging Unit)",
  新价格: "New Price",
  "新价格（HKD）": "New Price (HKD)",
  价格单位: "Price Unit",
  由: "By",
  "物料单位（订单）": "Material Unit (Order)",
  转换至: "Convert to",
  基本单位: "Base Unit",
  阶梯数量价格: "Tiered Quantity Price",
  新价格生效日期: "New Price Effective Date",
  价格有效期至: "Price Valid Until",
  物料等级: "Material Grade",
  旧价格: "Old Price",
  "旧价格（HKD）": "Old Price (HKD)",
  价格变动比率: "Price Change Rate",
  回传状态: "Feedback Status",
  元: "CNY",
  港元: "HKD",
  美元: "USD",
  个: "Pieces",
  千克: "KG",
  米: "M",
  请输入物料编号: "Please Enter Material Number",
  请选择日期: "Please Select Date",

  // RegisteredTab 注册列表
  注册列表: "Registration List",
  代注册: "Proxy Registration",
  邮箱邀请: "Email Invitation",
  共: "Total",
  条数据: "Records",
  删除确认: "Delete Confirmation",
  确定要删除供应商: "Are you sure you want to delete the supplier",
  吗: "",
  确认: "Confirm",
  邀请人: "Inviter",
  请输入邀请人名字: "Please Enter Inviter Name",
  请选择注册状态: "Please Select Registration Status",
  注册来源: "Registration Source",
  联系人: "Contact Person",
  联系电话: "Contact Phone",
  邀请日期: "Invitation Date",
  操作: "Action",
  编辑: "Edit",
  查看: "View",
  邀请子账号: "Invite Sub-account",

  // RegistrationModal Related
  供应商注册信息表: "Supplier Registration Information Form",
  编辑供应商信息: "Edit Supplier Information",
  审核供应商信息: "Review Supplier Information",
  查看供应商信息: "View Supplier Information",
  保存: "Save",
  关闭: "Close",
  获取国家列表失败: "Failed to Get Country List",
  已自动填充供应商信息: "Supplier Information Auto-filled",
  获取供应商详情失败请手动填写:
    "Failed to Get Supplier Details, Please Fill Manually",
  加载省份列表失败: "Failed to Load Province List",
  加载供应商详情失败: "Failed to Load Supplier Details",
  代注册成功: "Proxy Registration Successful!",
  编辑成功: "Edit Successful!",
  请完善必填项: "Please Complete Required Fields",

  // BankInfoTable Related
  公户: "Corporate Account",
  私户: "Personal Account",
  银行国家: "Bank Country",
  银行账户类型: "Account Type",
  开户行名称: "Bank Name",
  开户行行号: "Bank Code",
  银行账号: "Bank Account",
  SWIFT代码: "SWIFT Code",
  开户人单位: "Account Holder",
  SAP不存在提示:
    "Notice: SAP does not have these highlighted bank account numbers",

  // EmailInvite Related
  使用默认邮件模板: "Using Default Email Template",
  邮箱邀请发送成功: "Email Invitation Sent Successfully!",
  发送邮箱邀请失败请重试: "Failed to Send Email Invitation, Please Try Again",

  // query.tsx Form Configuration Related
  供应商名称: "Supplier Name",
  供应商邮箱: "Supplier Email",
  发送: "Send",
  供货信息: "Supply Information",
  请输入供应商名称: "Please Enter Supplier Name",
  请输入供应商名称或从下拉选择:
    "Please Enter Supplier Name or Select from Dropdown",
  请输入生产商名称或从下拉选择:
    "Please Enter Manufacturer Name or Select from Dropdown",
  请选择国家: "Please Select Country",
  请选择省份城市: "Please Select Province/City",
  请输入省份城市: "Please Enter Province/City",
  请输入邮编: "Please Enter",
  请输入街道: "Please Enter",
  请输入经营范围: "Please Enter",
  请输入姓氏: "Please Enter",
  请输入名字: "Please Enter",
  请选择部门: "Please Select Department",
  请输入电话号码: "Please Enter",
  邮箱格式不正确: "Email Format is Incorrect",
  审核通过: "Approved",
  请输入意见说明: "Please Enter...",
  开始日期: "Start Date",
  结束日期: "End Date",
  邮件主题: "Email Subject",
  请输入邮件主题: "Please Enter Email Subject",
  邀请文本: "Invitation Text",
  请输入邮请文本: "Please Enter Invitation Text",
  请输入或选择生产商名称: "Please Enter or Select Manufacturer Name",
  请选择营业有效期: "Please Select Business Valid Period",
  请输入统一社会信用代码商业登记号:
    "Please Enter Unified Social Credit Code/Business Registration Number",
  请选择企业类型: "Please Select Business Type",
  请选择语言: "Please Select Language",
  银行资料: "Bank Information",

  // formConfig2.tsx Related Translations
  二级物料类别: "Secondary Material Category",
  物料目的: "Material Purpose",

  // formConfig2 Validation Messages
  请选择采购小组: "Please Select Procurement Group",
  请选择货币: "Please Select Currency",
  请选择付款方式: "Please Select Payment Method",
  请选择付款条约: "Please Select Payment Terms",
  请选择国际贸易条款: "Please Select Incoterms",
  请选择科目小组: "Please Select Subject Group",
  请选择科目小组以自动填充科目编号:
    "Please Select Subject Group to Auto-fill Subject Number",
  请选择物料类别: "Please Select Material Category",
  请选择二级物料类别: "Please Select Secondary Material Category",
  请选择物料目的: "Please Select Material Purpose",
  请选择是否为GMP: "Please Select GMP Status",

  // formConfig2 Options Related
  Yes: "Yes",
  No: "No",
  API: "API",
  "辅料（Excipient）": "Excipient",
  包材: "Packaging Materials",
  RLD: "RLD",
  工程建设: "Engineering Construction",
  "设备/设施/仪器": "Equipment/Facilities/Instruments",
  MRO: "MRO",
  行政物资: "Administrative Materials",
  IT物资: "IT Materials",
  外包服务: "Outsourcing Services",
  "A类物料（战略物料）": "Type A Materials (Strategic Materials)",
  "B、C类物料+AF委外采购产品": "Type B, C Materials + AF Outsourced Products",
  OEM客户专用物料: "OEM Customer Exclusive Materials",
  一般供应商: "General Supplier",
  重点供应商: "Key Supplier",
  战略供应商: "Strategic Supplier",
  "C01 Dir.Matl-Plant 工厂-生产物料":
    "C01 Dir.Matl-Plant Factory-Production Materials",
  "C02 Indir.Matl-MRO 工厂-易耗品": "C02 Indir.Matl-MRO Factory-Consumables",
  "C03 Indir.Matl-Other 工厂-固定资产/项目":
    "C03 Indir.Matl-Other Factory-Fixed Assets/Projects",
  "C04 Dir.Matl-Other 研发-小试物料": "C04 Dir.Matl-Other R&D-Pilot Materials",
  "C05 Dir.Matl-For E5 工厂-生产物料":
    "C05 Dir.Matl-For E5 Factory-Production Materials",
  "C06 Idir.Matl-R&D 研发-固定资产/项目":
    "C06 Idir.Matl-R&D R&D-Fixed Assets/Projects",
  "C07 Dir.Matl-Scale-up 研发-中试物料":
    "C07 Dir.Matl-Scale-up R&D-Scale-up Materials",
  HKD: "HKD",
  CNY: "CNY",
  EUR: "EUR",
  USD: "USD",
  GBP: "GBP",
  TWD: "TWD",
  AUD: "AUD",
  JPY: "JPY",
  VND: "VND",
  CHF: "CHF",
  TT: "TT",
  Cheque: "Cheque",
  Other: "Other",
  "Advance payment": "Advance payment",
  "Cash on Delivery": "Cash on Delivery",
  "Advance payment by progress, refer to remark":
    "Advance payment by progress, refer to remark",
  "Deposit and progress payment, refer to remark":
    "Deposit and progress payment, refer to remark",
  "L/C 120 days": "L/C 120 days",
  "L/C 15 days": "L/C 15 days",
  "L/C 30 days": "L/C 30 days",
  "L/C 45 days": "L/C 45 days",
  "L/C 60 days": "L/C 60 days",
  "L/C 75 days": "L/C 75 days",
  "L/C 90 days": "L/C 90 days",
  "L/C at sight": "L/C at sight",
  "30 days from month end": "30 days from month end",
  "35 days from month end": "35 days from month end",
  "45 days from month end": "45 days from month end",
  "Net due on 7 days": "Net due on 7 days",
  "Net due on 14 days": "Net due on 14 days",
  "Net due on 15 days": "Net due on 15 days",
  "Net due on 30 days": "Net due on 30 days",
  "Net due on 35 days": "Net due on 35 days",
  "Net due on 40 days": "Net due on 40 days",
  "Net due on 45 days": "Net due on 45 days",
  "Net due on 60 days": "Net due on 60 days",
  "Net due on 75 days": "Net due on 75 days",
  "Net due on 85 days": "Net due on 85 days",
  "Net due on 90 days": "Net due on 90 days",
  "Net due on 120 days": "Net due on 120 days",
  "Cash against documents": "Cash against documents",
  "Costs and freight": "Costs and freight",
  "Costs, insurance & freight": "Costs, insurance & freight",
  "Carriage and insurance paid to": "Carriage and insurance paid to",
  "Carriage paid to": "Carriage paid to",
  "Delivered at frontier": "Delivered at frontier",
  "Delivered Duty Paid": "Delivered Duty Paid",
  "Delivered Duty Unpaid": "Delivered Duty Unpaid",
  "Delivered ex quay (duty paid)": "Delivered ex quay (duty paid)",
  "Delivered ex ship": "Delivered ex ship",
  "Ex Works": "Ex Works",
  "Free Alongside Ship": "Free Alongside Ship",
  "Free Carrier": "Free Carrier",
  "Free house": "Free house",
  "Free on board": "Free on board",
  "Not Free": "Not Free",
  "BF-Production Material Vendor": "BF-Production Material Vendor",
  "BF-Production Material Agent": "BF-Production Material Agent",
  "BF-Non-production Vendor": "BF-Non-production Vendor",
  "BF-Vendor (FI Only)": "BF-Vendor (FI Only)",
  "BF-Intercompany Vendor": "BF-Intercompany Vendor",
  "BF-Equipment Vendor": "BF-Equipment Vendor",
  "E1 Bright Future": "E1 Bright Future",
  "E2 BF Chinese Medicine": "E2 BF Chinese Medicine",
  "E4 SumaUS": "E4 SumaUS",
  "E5 SumaHK": "E5 SumaHK",

  // Required field validation messages
  请输入供应商编号: "Please Enter Supplier Number",
  "请选择供应商名称（中文）": "Please Select Supplier Name (Chinese)",
  "请选择供应商名称（英文）": "Please Select Supplier Name (English)",
  请选择采购类型: "Please Select Purchase Type",
  请选择是否为首次采购: "Please Select First Purchase Status",
};
